import React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ForeFlightLogo from '../../common/ForeFlightLogo';
import EuCookieBanner from './EuCookieBanner';

const StyledWrapper = styled('div')<{ isCompact: boolean }>`
    margin-bottom: ${({ isCompact }) => (isCompact ? '29px' : '65px')};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    a {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        color: inherit;

        .logo {
            margin-bottom: 13px;
        }
    }
`;

const Title = styled(Typography)`
    font-weight: 400;
    font-size: 37px;
    text-align: center;
`;

const SubTitle = styled(Typography)`
    font-weight: 100;
    font-size: 17px;
    text-align: center;
`;

interface Props {
    showWelcomeHeader: boolean;
    username?: string;
    onReset: () => void;
}
const ForeFlightHeader = ({ showWelcomeHeader, onReset, username = '' }: Props) => {
    return (
        <>
            <StyledWrapper isCompact={showWelcomeHeader}>
                <a href={'https://foreflight.com'}>
                    <ForeFlightLogo />
                </a>
                {!showWelcomeHeader && (
                    <>
                        <div className="foreflight-title">
                            <Title variant="h2">ForeFlight</Title>
                        </div>
                    </>
                )}
                {showWelcomeHeader && (
                    <>
                        <div className="foreflight-title">
                            <Title variant="h2">Welcome!</Title>
                            <SubTitle variant="h5">{username}</SubTitle>
                        </div>
                        <Button onClick={() => onReset()}>Not you?</Button>
                    </>
                )}
            </StyledWrapper>
            <EuCookieBanner />
        </>
    );
};
export default ForeFlightHeader;
